<template>
  <div>
    <h3>Kontaktid</h3>
    <b-card>
      <b-card-text>
        <p>Hääleta.ee rakendust haldab ja vahendab <strong>Postimees Grupp AS</strong></p>
        <p>
          <strong>Aadress:</strong>
          &nbsp;
          Maakri 23a, 10145 Tallinn, Eesti
        </p>
        <p>
          <strong>Telefon:</strong>
          &nbsp;
          +372 666 2350
        </p>
        <p>
          <strong>E-mail:</strong>
          &nbsp;
          <b-link href="mailto:haaleta@haaleta.ee">haaleta@haaleta.ee</b-link>
        </p>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: "Contact"
  }
</script>